import { c as _c } from "react/compiler-runtime";
import { useSubscriptionStatus } from './use-subscription-status';
export function useCodingAgentsAccess(installationId) {
  const $ = _c(3);
  const subscriptionStatus = useSubscriptionStatus(installationId);
  const t0 = subscriptionStatus.data?.canUseCodingAgents ?? false;
  let t1;
  if ($[0] !== subscriptionStatus || $[1] !== t0) {
    t1 = {
      ...subscriptionStatus,
      canUseCodingAgents: t0
    };
    $[0] = subscriptionStatus;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}